import { render, staticRenderFns } from "./discounts-details.vue?vue&type=template&id=d4401f7a&"
import script from "./discounts-details.vue?vue&type=script&lang=js&"
export * from "./discounts-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports